import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "./ui";
import { api } from "../services";
import { useTranslation } from "react-i18next";
import logo from "../assets/logos/logo.png";
import AuthPageLayout, { AuthSuccessIcon } from "./AuthPageLayout";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
    }
  }, [token, navigate]);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    if (!newPassword || !confirmPassword) {
      setError(t("Password is required."));
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t("Passwords do not match."));
      return;
    }
    setLoading(true);
    try {
      await api.post(`/reset-password/${token}`, { newPassword });
      setSuccess(true);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          t("An error occurred.", { defaultValue: "An error occurred." })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageLayout cardClassName={success ? "auth-page-card--status" : ""}>
      {success ? (
        <>
          <div className="auth-status-body">
            <AuthSuccessIcon />
            <h1 className="auth-page-card__title">
              {t("Password Updated", { defaultValue: "Password Updated" })}
            </h1>
            <p>
              {t("resetPassword.success", {
                defaultValue: "Your password has been updated. You can now log in.",
              })}
            </p>
          </div>
          <Button
            color="primary"
            size="md"
            className="auth-submit"
            onClick={() => navigate("/")}
          >
            {t("accountCreated.backToLogin", { defaultValue: "BACK TO LOGIN" })}
          </Button>
        </>
      ) : (
        <>
          <div className="auth-page-card__logo">
            <img src={logo} alt="Loops" />
          </div>
          <h1 className="auth-page-card__title">{t("Reset Password")}</h1>
          <p className="auth-page-card__subtitle">
            {t("resetPassword.subtitle", {
              defaultValue: "Choose a new password for your account.",
            })}
          </p>

          <form className="auth-form" onSubmit={handleResetPassword} noValidate>
            <div className="auth-field">
              <input
                id="new-password"
                type="password"
                autoComplete="new-password"
                placeholder={t("Enter New Password")}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="auth-field">
              <input
                id="confirm-new-password"
                type="password"
                autoComplete="new-password"
                placeholder={t("Re-enter New Password")}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            {error ? <p className="auth-form-error">{error}</p> : null}

            <Button
              type="submit"
              color="primary"
              size="md"
              className="auth-submit"
              disabled={loading}
            >
              {loading
                ? t("Updating...", { defaultValue: "Updating..." })
                : t("update")}
            </Button>
          </form>

          <div className="auth-links-row" style={{ justifyContent: "center" }}>
            <Link to="/" className="auth-link-muted">
              {t("accountCreated.backToLogin", { defaultValue: "BACK TO LOGIN" })}
            </Link>
          </div>
        </>
      )}
    </AuthPageLayout>
  );
}

export default ResetPassword;
